// Funções utilitárias de autenticação e cache

export const isLoggedInToday = () => {
  const logado = localStorage.getItem('logado') === 'S';
  const loginDate = localStorage.getItem('loginDate');
  const today = new Date().toISOString().split('T')[0];
  return logado && loginDate === today;
};

export const setLoginToday = (usuario, loja, sap, codigorest) => {
  const today = new Date().toISOString().split('T')[0];
  let chapaFormatada = String(usuario).padStart(6, '0');

  localStorage.setItem("logado", "S");
  localStorage.setItem("loginDate", today);
  localStorage.setItem("chapa", chapaFormatada);
  localStorage.setItem("loja", loja || "");
  localStorage.setItem("acessoSAP", sap || "N");
  localStorage.setItem("codigorest", codigorest || "");

  // Limpa cache e força reload total ao logar
  clearBrowserCache();
};

// Limpa cache de navegador
export const clearBrowserCache = () => {
  try {
    if ('caches' in window) {
      caches.keys().then(names => {
        for (let name of names) caches.delete(name);
      });
    }
    if (window.performance && window.performance.clearResourceTimings) {
      window.performance.clearResourceTimings();
    }
    localStorage.removeItem('v');
  } catch (e) {
    console.warn("Erro limpando cache:", e);
  }
};

// Logout completo - PRESERVA OS FAVORITOS NO LOCALSTORAGE
export const logout = () => {
  // 1. Mapeia e salva temporariamente todas as chaves de favoritos
  const favoritosBackup = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith("favoritos_")) {
      favoritosBackup[key] = localStorage.getItem(key);
    }
  }

  // 2. Limpa as sessões e credenciais
  localStorage.clear();

  // 3. Restaura os favoritos preservados
  Object.keys(favoritosBackup).forEach((key) => {
    localStorage.setItem(key, favoritosBackup[key]);
  });

  clearBrowserCache();
  setTimeout(() => {
    window.location.href = "/arbor/login";
  }, 300);
};